import { __rest } from "tslib";
import { createElement, forwardRef } from 'rax';
import classNames from 'classnames';
import Children from 'rax-children';
import cloneElement from 'rax-clone-element';
import View from '../view';
const ButtonGroup = (props, ref) => {
    const { prefix = 'mt-', size, model, className, children } = props, other = __rest(props, ["prefix", "size", "model", "className", "children"]);
    return (<View ref={ref} className={classNames(`${prefix}button-group`, className)} {...other}>
      {Children.map(children, (child, index) => {
            return cloneElement(child, {
                key: `mt_button_${index}`,
                model,
                size,
            });
        })}
    </View>);
};
ButtonGroup.displayName = 'Button.Group';
export default forwardRef(ButtonGroup);
